// removed by extract-text-webpack-plugin
module.exports = {"block":"_3LCspalIFbgRykQPg-T2T3","background":"_3SzB4HPl8pYjchJJ62KW2Q","heading":"_3vXsfjBGM-0ls8ZPoRizRz","wrapper":"a0oonTc8FI_TWMN8Lmsqm","group":"_1_ymvQ_xVh6509sbkCWBTy","links":"_3iCcDoMAb_37qVBjVql2iZ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/LinkGroupListBlock/LinkGroupListBlock.module.scss
// module id = 783
// module chunks = 0